export const COMING_SOON = {
  HEADING: "We are coming soon",
  SUBTITLE:
    "We are almost there! If you want to get notified when the website goes live, subscribe to our mailing list!",
};
